export default __webpack_public_path__ + "static/media/Disclosure-Notice.c10e4ee3.pdf";